import { writable } from 'svelte/store';
export const storePages = writable([]);
export const storePage = writable("");
export const emptyPage = {
    id: 0,
    title: "",
    text: "",
    shutters: []
};
